<!-- Краткий гайд подключения бота из мессенджера MAX на вкладке чат-интеграций -->
<template>
  <section class="max-bot-guide" aria-label="Как подключить бота из мессенджера MAX">
    <div class="max-bot-guide__logo">
      <AppIcon name="max" :size="46" variant="colored" />
    </div>
    <div class="max-bot-guide__content">
      <h4 class="max-bot-guide__title">Как подключить бота MAX</h4>
      <ol class="max-bot-guide__steps">
        <li>
          Откройте
          <a
            class="max-bot-guide__link"
            href="https://business.max.ru/"
            target="_blank"
            rel="noopener noreferrer"
          >
            MAX для бизнеса
            <AppIcon name="externalLink" :size="13" />
          </a>
          и создайте бота.
        </li>
        <li>Дождитесь одобрения и скопируйте токен бота.</li>
        <li>
          В Трако нажмите «Создать бота», укажите название и вставьте токен.
        </li>
        <li>Включите бота в списке интеграций.</li>
        <li>Напишите боту в MAX и проверьте, что сообщение появилось в разделе «Чаты».</li>
      </ol>
    </div>
  </section>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";

export default {
  name: "IntegrationMaxBotConnectionGuide",
  components: {
    AppIcon,
  },
};
</script>

<style scoped>
.max-bot-guide {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  display: flex;
  overflow: hidden;
  padding: 0;
}

.max-bot-guide__logo {
  align-items: center;
  align-self: stretch;
  background: #ffffff;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  min-height: 120px;
  width: 112px;
}

.max-bot-guide__content {
  min-width: 0;
  padding: 14px 16px;
}

.max-bot-guide__title {
  color: #333;
  font-size: 15px;
  font-weight: 600;
  margin: 0 0 8px;
}

.max-bot-guide__steps {
  color: #666;
  display: flex;
  flex-direction: column;
  font-size: 13px;
  gap: 6px;
  line-height: 1.4;
  list-style-position: inside;
  margin: 0;
  padding: 0;
}

.max-bot-guide__link {
  align-items: center;
  color: #2246ff;
  display: inline-flex;
  font-weight: 600;
  gap: 3px;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.max-bot-guide__link:hover {
  color: #8315ff;
}

@media (max-width: 560px) {
  .max-bot-guide {
    align-items: flex-start;
  }

  .max-bot-guide__logo {
    min-height: 148px;
    width: 72px;
  }
}
</style>
